import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";

export default function ChooseB2BModal({
  chooseB2BModelVisible,
  setChooseB2BModelVisible,
  sendDataToChooseB2BModel
}) {

  const [checkedB2BModel, setCheckedB2BModel] = useState(true)
  const [normalBooking, setNormalBooking] = useState(false)
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const handleModalClose = () => {
    setChooseB2BModelVisible(false);
  };

  useEffect(() => {
    if (checkedB2BModel && normalBooking) {
      setIsSubmitButtonPressed(true)
    } else {
      setIsSubmitButtonPressed(false)
    }

  }, [checkedB2BModel, normalBooking])


  const handleSubmit = () => {

    if (checkedB2BModel || normalBooking) {
      sendDataToChooseB2BModel({
        B2BModelEnabled: checkedB2BModel ? true : false,
      });
      setChooseB2BModelVisible(false);
    } else {
      setIsSubmitButtonPressed(true)
    }
  }

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={chooseB2BModelVisible}
        style={{ width: "30vw" }}
        onHide={() => {
          if (!chooseB2BModelVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
              height: "35vh",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>
              <div className="flex   justify-content-center align-items-center gap-2">
                <div className="flex justify-content-center align-items-center">
                  <p className="text-white-alpha-90 text-xl text-primary-50 font-semibold text-center">
                    Select B2B or B2C
                  </p>
                </div>
              </div>
              <div></div>
            </div>
            <div
              className="h-40rem scroll-bar "
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="flex-1 my-1 mx-4">
                <div className="flex-1 mx-2 mb-1 mt-3 flex gap-3">
                  <div
                    className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <p
                      className=" text-md font-normal capitalize"
                      style={{ color: "#6b7280" }}
                    >
                      B2B
                    </p>
                    <div>
                      <Checkbox
                        onChange={() => {
                          setCheckedB2BModel(!checkedB2BModel)
                          if (!checkedB2BModel) {
                            setNormalBooking(false);
                          } else {
                            setNormalBooking(true);
                          }
                        }
                        }
                        checked={checkedB2BModel}
                      ></Checkbox>
                    </div>
                  </div>
                  <div
                    className="border-round-lg shadow-2 flex flex-1 px-3 py-2 justify-content-between"
                    style={{
                      backgroundColor: "#fff",
                    }}
                  >
                    <p
                      className=" text-md font-normal capitalize"
                      style={{ color: "#6b7280" }}
                    >
                      B2C
                    </p>
                    <div>
                      <Checkbox
                        onChange={() => {
                          setNormalBooking(!normalBooking)
                          if (!normalBooking) {
                            setCheckedB2BModel(false);
                          } else {
                            setCheckedB2BModel(true);
                          }
                        }

                        }
                        checked={normalBooking}
                      ></Checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex-1 text-center mt-2">
                <Button
                  disabled={isSubmitButtonPressed}
                  onClick={handleSubmit}
                  className="mt-1 mb-2 mx-4 border-round-xl "
                >
                  <p className=" w-full text-xl  font-semibold flex justify-content-center">
                    CONTINUE
                  </p>
                </Button>
                {isSubmitButtonPressed && <p className="text-md  font-semibold flex justify-content-center" style={{ color: 'red' }}>Please Select Any One</p>}
              </div>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
}
